import { MathExpression } from '@/api/dashboard'

export interface ParseResult {
  success: boolean
  expression?: MathExpression
  error?: string
}

export enum MathOperatorType {
  '+' = '+',
  '-' = '-',
  '*' = '*',
  '/' = '/',
  '^' = '^',
  '%' = '%',
  '(' = '(',
  ')' = ')',
}
